<template>
    <section>
        <titlebar :title-stack="titleStack"></titlebar>
        <div class="columns box">
            <div class="column is-5">
                <b-field>
                    <b-input :placeholder="$t('REPASSEMEDICOLISTA.PROCURAR')"
                             v-model="procurar"
                             icon="magnify"
                             @input="loadAsyncData"></b-input>
                </b-field>
            </div>
            <div class="column">
                <div class="buttons">                       
                    <router-link v-if="isInRole('repassemedico-alterar')" :to="{ name: 'repassemedico' }" class="button is-primary">
                        {{$t('REPASSEMEDICOLISTA.INCLUIR')}}
                    </router-link>
                </div>
            </div>
            <div class="column is-2">
                <form @submit.prevent="abrirCadastroInput">
                    <b-field>
                        <b-input :placeholder="$t('REPASSEMEDICOLISTA.CODIGO')"
                                 v-model="id"
                                 type="number"
                                 icon-right="edit"
                                 icon-right-clickable
                                 @icon-right-click="abrirCadastroInput">
                        </b-input>
                    </b-field>
                </form>
            </div>
        </div>

        <b-table :data="model.lista"
                :loading="loading"
                paginated
                striped
                hoverable
                backend-pagination
                :total="total"
                @page-change="onPageChange"
                :aria-next-label="$t('REPASSEMEDICOLISTA.PROXPAGINA')"
                :aria-previous-label="$t('REPASSEMEDICOLISTA.PAGANTERIOR')"
                :aria-page-label="$t('REPASSEMEDICOLISTA.PAGINA')"
                :aria-current-label="$t('REPASSEMEDICOLISTA.PAGATUAL')"
                backend-sorting
                :default-sort-direction="defaultOrdenar"
                :default-sort="[ordenarPor, ordenar]"
                sort-icon-size="is-small"
                 @sort="onSort">
            <template>
                <b-table-column  v-slot="props" field="id" :label="$t('REPASSEMEDICOLISTA.CODIGO')" sortable>
                    {{ props.row.id }}
                </b-table-column>

                <b-table-column  v-slot="props" field="Nome" :label="$t('REPASSEMEDICOLISTA.NOME')" width="45%" sortable>
                    {{ props.row.nome }}
                </b-table-column>

                <b-table-column  v-slot="props" field="Médico" :label="$t('REPASSEMEDICOLISTA.MEDICO')" width="30%" sortable>
                    {{ props.row.medico.nome }}
                </b-table-column>

                <b-table-column  v-slot="props" field="Valor Mínimo" :label="$t('REPASSEMEDICOLISTA.VALORMINIMO')" width="10%" sortable>
                    {{ props.row.valorMinimo }}
                </b-table-column>

                <b-table-column  v-slot="props" field="Tabela" :label="$t('REPASSEMEDICOLISTA.TABELADEEXAMES')" width="15%" sortable>
                    <span v-if="props.row.tabelaPreco">{{ props.row.tabelaPreco.nome }}</span>
                    <span v-else> </span>
                </b-table-column>

                <b-table-column  v-slot="props" field="Setor" :label="$t('REPASSEMEDICOLISTA.SETOR')" sortable>
                    <span v-if="props.row.setor">{{ props.row.setor.nome }}</span>
                    <span v-else> </span>
                </b-table-column>

                <b-table-column  v-slot="props" field="Convenio" :label="$t('REPASSEMEDICOLISTA.CONVENIO')" sortable>
                    <span v-if="props.row.convenio">{{ props.row.convenio.nome }}</span>
                    <span v-else> </span>
                </b-table-column>

                <b-table-column  v-slot="props" field="Porcentagem" :label="$t('REPASSEMEDICOLISTA.PORCENTAGEM')" sortable>
                    {{ props.row.porcentagem }}
                </b-table-column>
                
                <b-table-column  v-slot="props" field="Impostos" :label="$t('REPASSEMEDICOLISTA.IMPOSTOS')">
                    {{ props.row.impostos }}
                </b-table-column>

                <b-table-column  v-slot="props" custom-key="actions" numeric>
                    <router-link :to="{ name: 'repassemedico', params: { id: props.row.id }}" class="button is-small is-primary" title="Editar">
                        <b-icon icon="pencil" size="is-small"></b-icon>
                    </router-link>
                </b-table-column>

            </template>
        </b-table>

    </section>
</template>

<script>
    import { mapGetters } from 'vuex'
    import titlebar from '@/components/titlebar.vue'

    export default {
        data() {
            return {
                model: [],
                loading: false,
                total: 0,
                defaultOrdenar: 'asc',
                ordenarPor: 'Nome',
                ordenar: 'asc',
                page: 1,
                perPage: 20,
                procurar: this.$route.query.procurar ?? ""
            }
        },
        components: {
            titlebar
        },
        computed: {
            titleStack() {
                return [
                    this.$t('REPASSEMEDICOCADASTRO.MANUTENCAO'),
                    this.$t('REPASSEMEDICOCADASTRO.REPASSEMEDICO'),
                ]
            },
            ...mapGetters([
                'isInRole'
            ])
        },
        mounted(){
            this.loadAsyncData();
        },
        methods: {
            loadAsyncData() {
                const params = [
                    `procurar=${this.procurar}`,
                    `ordem=${this.ordenarPor}.${this.ordenar}`,
                    `page=${this.page}`,
                    `perPage=${this.perPage}`
                ].join('&');

                this.loading = true;
                this.$http.get(`/api/manutencao/repassesmedicos?${params}`)
                    .then(({ data }) => {
                        this.model = data;
                        this.total = this.perPage * data.pageCount
                        this.loading = false
                    })
                    .catch((error) => {
                        this.model = []
                        this.total = 0
                        this.loading = false
                        throw error
                    })
            },
            onPageChange(page) {
                this.page = page
                this.loadAsyncData()
            },
            onSort(field, order) {
                this.ordenarPor = field
                this.ordenar = order
                this.loadAsyncData()
            },
            abrirCadastroInput() {
                this.$router.push({ path: `/manutencao/repassemedico/${this.id}` })
            },
        }
    }
</script>